exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#main[data-v-57525946]{border:1px solid #494949}.title-box[data-v-57525946]{border-bottom:1px solid #494949;padding:.5rem 1rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-57525946","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SharedComponents/RatingFrame.vue
// module id = 361
// module chunks = 0